import { PublicLayout } from '../layouts/PublicLayout';
import { AppLayout } from '../layouts/AppLayout';
import { SignInLayout } from '../layouts/SignInLayout';
import { AccountLayout } from '../layouts/AccountLayout';
import { NotFoundPage } from './NotFoundPage';
import { StartPage } from './StartPage';
import { AuthSignInPage } from './AuthSignInPage';
import { SignInPage } from './SignInPage';
import { DashboardPage } from './DashboardPage';
import { AccountPage } from './AccountPage';
import { SubscriptionThankYouPage } from './SubscriptionThankYouPage';
import { AccountPurchasesPage } from './AccountPurchasesPage';
import { AccountDeletePage } from './AccountDeletePage';
import { AccountPaymentHistoryPage } from './AccountPaymentHistoryPage';
import { PremiumPage } from './PremiumPage';
import { AboutUsPage } from './AboutUsPage';
import { ContactUsPage } from './ContactUsPage';

const pagePathnames = {
    start: '/',
    dashboard: '/dashboard',
    authEmailSignIn: '/auth/email/sign-in',
    signIn: '/sign-in',
    premium: '/premium',
    aboutUs: '/about-us',
    account: '/account',
    purchases: '/account/purchases',
    paymentHistory: '/account/payment-history',
    delete: '/account/delete',
    subscriptionThankYou: '/subscription/:subscriptionId/thank-you',
    blog: 'https://futureproof.app/blog',
    contactUs: '/contact-us',
    impressum: '/impressum',
    notFound: '*'
};

const pageRoutes = [
    {
        path: pagePathnames.start,
        page: StartPage,
        layout: PublicLayout,
        isProtected: false
    },
    {
        path: pagePathnames.signIn,
        page: SignInPage,
        layout: SignInLayout,
        isProtected: false
    },
    {
        path: pagePathnames.authEmailSignIn,
        page: AuthSignInPage,
        layout: SignInLayout,
        isProtected: false
    },
    {
        path: pagePathnames.notFound,
        page: NotFoundPage,
        isProtected: false
    },
    {
        path: pagePathnames.premium,
        page: PremiumPage,
        layout: AppLayout,
        isProtected: true
    },
    {
        path: pagePathnames.account,
        page: AccountPage,
        container: AccountLayout,
        containerProps: { isPremiumFeature: true },
        layout: AppLayout,
        isProtected: true
    },
    {
        path: pagePathnames.purchases,
        page: AccountPurchasesPage,
        container: AccountLayout,
        layout: AppLayout,
        isProtected: true
    },
    {
        path: pagePathnames.paymentHistory,
        page: AccountPaymentHistoryPage,
        container: AccountLayout,
        layout: AppLayout,
        isProtected: true
    },
    {
        path: pagePathnames.delete,
        page: AccountDeletePage,
        container: AccountLayout,
        layout: AppLayout,
        isProtected: true
    },
    {
        path: pagePathnames.dashboard,
        page: DashboardPage,
        layout: AppLayout,
        isProtected: true
    },
    {
        path: pagePathnames.aboutUs,
        page: AboutUsPage,
        layout: PublicLayout,
        isProtected: false
    },
    {
        path: pagePathnames.subscriptionThankYou,
        page: SubscriptionThankYouPage,
        layout: PublicLayout,
        isProtected: false
    },
    {
        path: pagePathnames.contactUs,
        page: ContactUsPage,
        layout: PublicLayout,
        isProtected: false
    },
    {
        path: pagePathnames.impressum,
        page: ContactUsPage,
        layout: PublicLayout,
        isProtected: false
    }
];

export {
    pagePathnames,
    pageRoutes
};
